import {FC} from "react";
import {TabBlockAside, TabP, TabTitle, TabTitleDark} from "../../styles";
import ImgRadar from "../../../../assets/images/metodology-radar.svg";
import ImgArrowRight from "../../../../assets/images/icon-tab-arrow-toright.svg";
import ImgVolumeWorldMarket from "../../../../assets/images/metodology-volume-world-market.svg";
import ImgMapShema from "../../../../assets/images/karta-tehnology-shema.svg";
import ImgWorldIcon from "../../../../assets/images/metodology-world-icon.svg";
import ImgDollarFlower from "../../../../assets/images/metodology-dollar-flower.svg";
import ImgDollarFlowerIcon from "../../../../assets/images/metodology-dollar-flower-icon.svg";
import ImgPotentialGrowRussia from "../../../../assets/images/metodology-potential-grow-russia.svg";
import ImgFlashIcon from "../../../../assets/images/metodology-flesh-icon.svg";
import ImgGPBLogo from "../../../../assets/images/metodology-gpb-logo.svg";
import ImgGPBLogoIcon from "../../../../assets/images/metodology-gpb-logo-icon.svg";
import ImgEagle from "../../../../assets/images/metodology-eagle.svg";
import ImgFlagRussia from "../../../../assets/images/flag-russia-icon.svg";
import ImgShesterenka from "../../../../assets/images/metodology-shesterenka.svg";
import ImgShesterenkaIcon from "../../../../assets/images/metodology-shesterenka-icon.svg";

export const TabInfoTwo: FC = () => {
  return (
    <div>
      <TabTitle style={{color: "rgba(255, 255, 255, 0.6"}}>
        Атрибуты технологических кластеров
      </TabTitle>
      <br />
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            gap: 20,
          }}
        >
          <div style={{width: "45%"}}>
            <img src={ImgRadar} alt="" width={220} />
          </div>
          <div style={{width: "55%"}}>
            <TabTitle>Зрелость технологического кластера в России</TabTitle>
            <TabP>Степень развития и готовности кластера в России.</TabP>
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              А) Анализ публикационной и патентной активности по кластеру в
              мире;
            </TabP>

            <TabP>
              Б) Анализ публикационной и патентной активности по кластеру в
              России;
            </TabP>

            <TabP>В) Распределение кластеров по трем группам зрелости:</TabP>

            <TabP>
              <div
                dangerouslySetInnerHTML={{
                  __html: `< 33 процентиля — низкая зрелость;<br />
<= 66 процентиля — средняя зрелость;<br />
> 66 процентиля — высокая зрелость.`,
                }}
              />
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Открытые источники: исследования, статьи, патенты и проч.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgVolumeWorldMarket} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Объем мирового рынка к 2030 г.</TabTitle>
            <TabP>
              Теоретическая величина спроса на продукт или услугу в мире к 2030
              году.
            </TabP>
            <TabP>
              На Карте технологий отображается полупрозрачной областью вокруг
              технологии. Величина ее радиуса зависит от величины рынка.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 50,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: 10,
                }}
              >
                <img src={ImgMapShema} alt="" width={30} />
                <TabP>На Карте технологий</TabP>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: 10,
                }}
              >
                <img src={ImgWorldIcon} alt="" width={30} />
                <TabP>В описании кластера и поисковых фильтрах</TabP>
              </div>
            </div>
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Для расчета используются оценки ведущих консалтинговых компаний и
              отраслевых аналитических центров, а также оценка ДАВТ с
              индивидуально расчетной методологией для каждой технологии.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Открытые источники: исследования, статьи, патенты и проч.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgDollarFlower} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>
              Совокупный объем мировых инвестиций в стартапыза 2023-2024 гг.,
              млн долл.
            </TabTitle>
            <TabP>
              Фактическая сумма мировых инвестиций в период 2023-2024 гг.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgDollarFlowerIcon} alt="" width={25} />
              <TabP>В описании кластера и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Сумма мировых инвестиций в рамках технологии, сделанных в период
              2023-2024 гг.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Международные базы данных венчурного капитала и прямых
                  инвестиций: Pitchbook, Crunchbase.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgEagle} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Кластеры в составе Национальных проектов</TabTitle>
            <TabP>
              Национальные приоритеты государства в области научного и
              технологического развития.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgFlagRussia} alt="" width={25} />
              <TabP>В описании кластера и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Сопоставление с перечнем технологий, выделенных в паспортах
              Национальныхи Федеральных проектов России.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Указ Президента Российской Федерации от 18.06.2024 № 529.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgShesterenka} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>
              Критические и сквозные технологические кластеры в России
            </TabTitle>
            <TabP>
              Критически необходимые и перспективные кластеры технологий
              межотраслевого назначения.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgShesterenkaIcon} alt="" width={25} />
              <TabP>В описании кластера и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>
              Сопоставление с перечнем критических и сквозных технологий в
              России.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Указ Президента Российской Федерации от 18.06.2024 № 529.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgPotentialGrowRussia} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>
              Потенциал роста технологического кластера в России
            </TabTitle>
            <TabP>
              Совокупность прямых и косвенных экономических выгод, полученных в
              результате применения технологий, входящих в состав кластера.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgFlashIcon} alt="" width={25} />
              <TabP>В описании кластера и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>Многофакторный анализ, включающий:</TabP>
            <TabP style={{marginBottom: 1}}>
              А) Потенциальный объем мирового рынка;
            </TabP>
            <TabP style={{marginTop: 1}}>Б) Объем инвестиций.</TabP>
            <TabP>
              При наличии в совокупности объема мирового рынка и объема
              инвестицийна уровне «Выше среднего» (5/6 или 6/6 по сумме
              индикаторов А и Б), кластеру присваивается отметка о потенциальном
              экономической эффекте.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  <TabP style={{marginBottom: 1}}>
                    А) Открытые источники: исследования, статьи и пр.;
                  </TabP>
                  <TabP style={{marginTop: 1}}>
                    Б) Опросы внутренних и внешних экспертов Банка.
                  </TabP>
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgGPBLogo} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Присутствие ГПБ</TabTitle>
            <TabP>
              Технологические кластеры, содержащие в составе технологии, в
              рамках которых Банк имеет соответствующие активы.
            </TabP>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 30,
              }}
            >
              <img src={ImgGPBLogoIcon} alt="" width={25} />
              <TabP>В описании кластера и поисковых фильтрах</TabP>
            </div>
            <div style={{height: 10}} />
            <TabTitleDark>Методология формирования и расчета</TabTitleDark>
            <TabP>Сопоставление с перечнем технологических активов банка.</TabP>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  <TabP style={{marginBottom: 1}}>
                    Внутренние данные Банка.
                  </TabP>
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
    </div>
  );
};
